import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "disabled"]
const _hoisted_2 = { class: "svg-slot" }



interface Props {
    id?: string
    disabled?: boolean
    classes?: string[]
    textClass?: string
}
interface Emits {
    (e: 'buttonClick'): void
}

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    id: {},
    disabled: { type: Boolean },
    classes: { default: () => ['button-primary', 'bg-primary-blue'] },
    textClass: { default: 'text-primary-white' }
  },
  emits: ["buttonClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// emit
const emit = __emit

// handlers
const handleClick = () => {
    if (props.disabled) return
    emit('buttonClick')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: props.id,
    onClick: _withModifiers(handleClick, ["prevent"]),
    class: _normalizeClass(["d-flex align-items-center justify-content-center w-100 h-100", props.classes]),
    disabled: props.disabled
  }, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "svg")
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["text-slot", [!props.disabled ? props.textClass : 'text-primary-white']])
    }, [
      _renderSlot(_ctx.$slots, "text", {}, () => [
        _cache[0] || (_cache[0] = _createTextVNode("Placeholder"))
      ])
    ], 2)
  ], 10, _hoisted_1))
}
}

})